"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonDark = exports.StyledButtonTertiary = exports.StyledButtonSecondary = exports.StyledButtonPrimary = void 0;
var primary_button_1 = require("./primary-button");
Object.defineProperty(exports, "StyledButtonPrimary", { enumerable: true, get: function () { return primary_button_1.StyledButtonPrimary; } });
var secondary_button_1 = require("./secondary-button");
Object.defineProperty(exports, "StyledButtonSecondary", { enumerable: true, get: function () { return secondary_button_1.StyledButtonSecondary; } });
var tertiary_button_1 = require("./tertiary-button");
Object.defineProperty(exports, "StyledButtonTertiary", { enumerable: true, get: function () { return tertiary_button_1.StyledButtonTertiary; } });
var dark_button_1 = require("./dark-button");
Object.defineProperty(exports, "StyledButtonDark", { enumerable: true, get: function () { return dark_button_1.StyledButtonDark; } });
//# sourceMappingURL=index.js.map